import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppComponent } from "src/app/app.component";
import { ContactFormComponent } from "./contact/contact-form/contact-form.component";
import { ContactPhoneComponent } from "./contact/contact-phone/contact-phone.component";
import { ContactComponent } from "./contact/contact.component";
import { CategoriesContentComponent } from "./create-ur-store/categories/categories-content/categories-content.component";
import { CategoriesComponent } from "./create-ur-store/categories/categories.component";
import { CategotiesHeaderComponent } from "./create-ur-store/categories/categoties-header/categoties-header.component";
import { CreateUrStoreComponent } from "./create-ur-store/create-ur-store.component";
import { AboutSectionComponent } from "./home/about-section/about-section.component";
import { CompVideoComponent } from "./home/comp-video/comp-video.component";
import { HomeSliderComponent } from "./home/home-slider/home-slider.component";
import { HomeComponent } from "./home/home.component";
import { OurClientsComponent } from "./home/our-clients/our-clients.component";
import { OurOffersComponent } from "./home/our-offers/our-offers.component";
import { OurPortfolioComponent } from "./home/our-portfolio/our-portfolio.component";
import { ProjectDetailsComponent } from "./project-details/project-details.component";
import { FatcBoxesComponent } from "./reusable/fatc-boxes/fatc-boxes.component";
import { BottomFooterComponent } from "./reusable/footer/bottom-footer/bottom-footer.component";
import { FooterComponent } from "./reusable/footer/footer.component";
import { MainFooterComponent } from "./reusable/footer/main-footer/main-footer.component";
import { TopFooterComponent } from "./reusable/footer/top-footer/top-footer.component";
import { LoaderComponent } from "./reusable/loader/loader.component";
import { MainNavComponent } from "./reusable/nav/main-nav/main-nav.component";
import { NavComponent } from "./reusable/nav/nav.component";
import { TopNavComponent } from "./reusable/nav/top-nav/top-nav.component";
import { PackagesComponent } from "./reusable/packages/packages.component";
import { SocilMediaComponent } from "./reusable/socil-media/socil-media.component";
import { AllLessonsComponent } from "./static/all-lessons/all-lessons.component";
import { CarsAppComponent } from "./static/cars-app/cars-app.component";
import { DesktopCodesrootsComponent } from "./static/desktop-page/desktop-codesroots/desktop-codesroots.component";
import { DesktopInfoComponent } from "./static/desktop-page/desktop-info/desktop-info.component";
import { DesktopIntroComponent } from "./static/desktop-page/desktop-intro/desktop-intro.component";
import { DesktopPageComponent } from "./static/desktop-page/desktop-page.component";
import { HostingPageComponent } from "./static/hosting-page/hosting-page.component";
import { LearningIntroComponent } from "./static/learning-page/learning-intro/learning-intro.component";
import { LearningPageComponent } from "./static/learning-page/learning-page.component";
import { LessonDetailsComponent } from "./static/lesson-details/lesson-details.component";
import { AdsSectionComponent } from "./static/marketing-page/ads-section/ads-section.component";
import { MarketingPageComponent } from "./static/marketing-page/marketing-page.component";
import { MarketingServiceComponent } from "./static/marketing-page/marketing-service/marketing-service.component";
import { MarketingWhyCodesrootsComponent } from "./static/marketing-page/marketing-why-codesroots/marketing-why-codesroots.component";
import { MobileCodesrootsComponent } from "./static/mobile-page/mobile-codesroots/mobile-codesroots.component";
import { MobileIntroComponent } from "./static/mobile-page/mobile-intro/mobile-intro.component";
import { MobilePageComponent } from "./static/mobile-page/mobile-page.component";
import { MobileWorkComponent } from "./static/mobile-page/mobile-work/mobile-work.component";
import { CodesrootsSeoFeaturesComponent } from "./static/seo-page/codesroots-seo-features/codesroots-seo-features.component";
import { SeoPageComponent } from "./static/seo-page/seo-page.component";
import { SeoServiceComponent } from "./static/seo-page/seo-service/seo-service.component";
import { WhatIsSeoComponent } from "./static/seo-page/what-is-seo/what-is-seo.component";
import { ShopCodesrootsComponent } from "./static/shop-page/shop-codesroots/shop-codesroots.component";
import { ShopIntroComponent } from "./static/shop-page/shop-intro/shop-intro.component";
import { ShopPageComponent } from "./static/shop-page/shop-page.component";
import { ShopWorkComponent } from "./static/shop-page/shop-work/shop-work.component";
import { SupportPageComponent } from "./static/support-page/support-page.component";
import { WebDesignSectionComponent } from "./static/web-page/web-design-section/web-design-section.component";
import { WebPageComponent } from "./static/web-page/web-page.component";
import { WhyCodesrootsComponent } from "./static/web-page/why-codesroots/why-codesroots.component";

import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzBackTopModule } from "ng-zorro-antd/back-top";

import { SlickCarouselModule } from "ngx-slick-carousel";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CarouselModule } from "ngx-owl-carousel-o";
import { AppRoutingModule } from "src/app/app-routing.module";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { IMakeAppComponent } from "./i-make-app/i-make-app.component";
import { promoVideoComponent } from "./i-make-app/components/promo-video/promo-video.component";
import { CreatePackageComponent } from "./create-package/create-package.component";
import { Error404Component } from "./error404/error404.component";
import { RouterModule } from "@angular/router";
import { CreateTicketComponent } from "./create-ticket/create-ticket.component";
import { ChatRoomComponent } from "./chat-room/chat-room.component";
import { DateToLocalPipe } from "src/core/pipes/date.pipe";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { Home2Component } from "./home2/home2.component";
import { mainSectionHomeComponent } from "./home2/main-section-home/main-section-home.component";
import { OurServicesComponent } from "./home/our-services/our-services.component";
import { PortfolioSectionHome2Component } from "./home2/portfolio-section-home2/portfolio-section-home2.component";
import { StatisticsHome2Component } from "./home2/statistics-home2/statistics-home2.component";
import { StaffsHome2Component } from "./home2/staffs-home2/staffs-home2.component";
import { ImakeAppCarsIntroComponent } from './static/cars-app/components/imake-app-cars-intro/imake-app-cars-intro.component';
import { AdvertiseHomeComponent } from "./home/advertise-home/advertise-home.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/lang/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    TopNavComponent,
    MainNavComponent,
    SocilMediaComponent,
    HomeComponent,
    HomeSliderComponent,
    CompVideoComponent,
    AboutSectionComponent,
    OurPortfolioComponent,
    OurServicesComponent,
    OurOffersComponent,
    OurClientsComponent,
    ProjectDetailsComponent,
    ContactComponent,
    ContactPhoneComponent,
    ContactFormComponent,
    FooterComponent,
    TopFooterComponent,
    MainFooterComponent,
    BottomFooterComponent,
    LoaderComponent,
    FatcBoxesComponent,
    PackagesComponent,
    SupportPageComponent,
    SeoPageComponent,
    SeoServiceComponent,
    WhatIsSeoComponent,
    CodesrootsSeoFeaturesComponent,
    HostingPageComponent,
    WebPageComponent,
    WebDesignSectionComponent,
    WhyCodesrootsComponent,
    MarketingPageComponent,
    MarketingServiceComponent,
    AdsSectionComponent,
    MarketingWhyCodesrootsComponent,
    CarsAppComponent,
    DesktopPageComponent,
    DesktopIntroComponent,
    DesktopInfoComponent,
    DesktopCodesrootsComponent,
    MobilePageComponent,
    MobileIntroComponent,
    MobileCodesrootsComponent,
    MobileWorkComponent,
    ShopPageComponent,
    ShopCodesrootsComponent,
    ShopIntroComponent,
    ShopWorkComponent,
    LearningPageComponent,
    LearningIntroComponent,
    AllLessonsComponent,
    LessonDetailsComponent,
    CreateUrStoreComponent,
    CategoriesComponent,
    CategoriesContentComponent,
    CategotiesHeaderComponent,
    IMakeAppComponent,
    promoVideoComponent,
    Error404Component,
    CreatePackageComponent,
    CreateTicketComponent,
    ChatRoomComponent,
    Home2Component,
    DateToLocalPipe,
    mainSectionHomeComponent,
    PortfolioSectionHome2Component,
    StatisticsHome2Component,
    StaffsHome2Component,
    AdvertiseHomeComponent,
    ImakeAppCarsIntroComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    FormsModule,
    RouterModule,
    NzToolTipModule,
    SlickCarouselModule,
    NzModalModule,
    NzBackTopModule,
    ReactiveFormsModule,
    NzSpinModule,
    NzFormModule,
    NzInputModule,
    NzAutocompleteModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    FormsModule,
    CarouselModule,
    FormsModule,
    RouterModule,
    NzToolTipModule,
    SlickCarouselModule,
    NzModalModule,
    NzBackTopModule,
    ReactiveFormsModule,
    NzSpinModule,
    NzFormModule,
    NzInputModule,
    NzAutocompleteModule,
    ReactiveFormsModule,
    DateToLocalPipe,
    TranslateModule,
    PackagesComponent,
  ]
})
export class SharedModule {}
